import fetch from 'isomorphic-fetch'
import { authHeader, handleResponse } from './helpers'
import { API_URL } from '../../constants/Config'

export const connectorsService = {
  getConnectors,
  setAuth,
  disconnect,
}

async function getConnectors(auth_token, product) {
  const url = `${API_URL}/connectors?product=${product}`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token),
  }
  return fetch(url, options)
    .then(response => handleResponse(response))
    .then(response => response.connectors)
}

async function setAuth(auth_token, connector_name, product, connector_auth) {
  const url = `${API_URL}/connectors/${connector_name}?product=${product}`
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(connector_auth),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

// target: 'user' removes only the caller's own Zendesk login (E13, MCP server only);
// omitted, the API applies its default (the shared account connection).
async function disconnect(auth_token, connector_name, reset_data, target, product) {
  reset_data = reset_data || false
  let url = `${API_URL}/connectors/${connector_name}?reset=${reset_data}`
  if (product) url += `&product=${product}`
  if (target) url += `&target=${target}`
  const options = {
    method: 'DELETE',
    headers: authHeader(auth_token),
  }
  return fetch(url, options)
    .then(response => handleResponse(response))
    .then(response => response.connectors)
}
